$(function () {
    let pendingChange = false;

    $('#use-as-standby-terminal').on('change', function() {
        const isChecked = $(this).prop('checked');

        if (isChecked) {
            pendingChange = true;
            $(this).prop('checked', false);
            $('#standbyConfirmModal').modal('show');
        }
    });

    $('#confirmStandby').on('click', function() {
        $('#use-as-standby-terminal').prop('checked', true);
        pendingChange = false;

        $('#standbyConfirmModal').modal('hide');

        submitLocationDeviceData();
    });

    $('#standbyConfirmModal').on('hidden.bs.modal', function() {
        if (pendingChange) {
            $('#use-as-standby-terminal').prop('checked', false);
            pendingChange = false;
        }
    });

    function submitLocationDeviceData() {
        const formData = {};
        
        $('#organizer_settings_form').find('input, select, textarea').each(function() {
            const name = $(this).attr('name');

            if (name && name.startsWith('location_device')) {
                if ($(this).attr('type') === 'checkbox') {
                    if ($(this).is(':checked')) {
                        formData[name] = $(this).val();
                    }
                } else if ($(this).attr('type') === 'radio') {
                    if ($(this).is(':checked')) {
                        formData[name] = $(this).val();
                    }
                } else {
                    formData[name] = $(this).val();
                }
            }
        });

        $.ajax({
            type: 'POST',
            url: '/api/v1/private/location-device/update',
            data: formData,
            success: function(response) {
                if (response && response.success && response.location_id) {
                    $(window).off("beforeunload");
                    document.location.href = `/location/${response.location_id}/payment-standby-mode`;
                }
            },
            error: function(xhr, status, error) {
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    showToast({
                        type: 'error',
                        message: xhr.responseJSON.error.message || 'An error occurred while updating settings.',
                        duration: 3000
                    })

                     $('#use-as-standby-terminal').prop('checked', false);
                }
            }
        });

    }
})